import { z } from 'zod';

const categoryValues = [
	'fertilizer',
	'lime',
	'conditioner',
	'organic',
	'special',
	'defensive',
] as const;

export const ProductRequestSchema = z.object({
	name: z.string().min(1, 'Nome é obrigatório'),
	manufacturer: z.string().min(1, 'Fabricante é obrigatório'),
	category: z
		.string()
		.min(1, 'Categoria é obrigatória')
		.pipe(
			z.enum(categoryValues, { message: 'Selecione uma categoria válida' })
		),
	note: z.string().optional(),
});

export type ProductRequestSchemaType = z.infer<typeof ProductRequestSchema>;
